import { Line, Modal } from '@components';
import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { bool, func } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SkipModuleModalLayout = ({
  handleSkipModule,
  isVisible,
  setIsVisible,
}) => {
  const { i18n } = useTranslation();
  const { isTabletSM } = useScreenSize();

  return (
    <Modal
      firstButtonProps={{
        color: theme.colors.white[100],
        px: isTabletSM ? 47 : 85,
        py: 22,
        variant: 'secondary',
      }}
      firstButtonText={i18n
        .t('ProfilePage.DeleteProfile.Modal.Cancel')
        .toUpperCase()}
      isVisible={isVisible}
      modalContainerProps={{
        backgroundColor: theme.colors.white[10],
        border: `1px solid ${theme.colors.white[10]}`,
        borderRadius: '0px',
        height: '100%',
        maxHeight: isTabletSM ? '100%' : '450px',
      }}
      modalMaxHeight="100%"
      modalMaxWidth={700}
      onSecondButtonClick={handleSkipModule}
      secondButtonProps={{
        px: isTabletSM ? 47 : 85,
        py: 22,
        variant: 'primary',
      }}
      secondButtonText={i18n
        .t('LearningMapPage.Modal.SkipModuleButton')
        .toUpperCase()}
      setModalVisible={setIsVisible}
      withBackdropNoise
      withBottomButtons
    >
      <Flex flexDirection="column" px={40} py={40}>
        <Typography
          color={theme.colors.white[100]}
          mb={2}
          variant="MS-semibold-s24-lh36"
        >
          {i18n.t('LearningMapPage.Modal.SkipModule')}
        </Typography>
        <Typography
          color={theme.colors.alto[100]}
          mb={4}
          variant="MS-regular-s16-lh25"
        >
          {i18n.t('LearningMapPage.Modal.SkipModuleSubtitle')}
        </Typography>
        <Line mb={4} />
        <Typography
          color={theme.colors.white[100]}
          variant="BN-regular-s36-lh43"
        >
          {i18n.t('LearningMapPage.Modal.CompleteQuestions')}
        </Typography>
      </Flex>
    </Modal>
  );
};

SkipModuleModalLayout.propTypes = {
  handleSkipModule: func.isRequired,
  isVisible: bool.isRequired,
  setIsVisible: func.isRequired,
};

export default SkipModuleModalLayout;
